"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var useDebounce_1 = require("./useDebounce");

exports.useDebounce = useDebounce_1.default;

var useDebouncedCallback_1 = require("./useDebouncedCallback");

exports.useDebouncedCallback = useDebouncedCallback_1.default;